import tableModule from './modules/table';

const state = {
  ...tableModule.state,
};

const getters = {
  ...tableModule.getters,
};

const actions = {
  ...tableModule.actions,
};

const mutations = {
  ...tableModule.mutations,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
